import React, { CSSProperties, PropsWithChildren } from 'react';
import { styled } from '@mui/system';
import Popover from '@mui/material/Popover';

export interface NewNotificationPanelProps {
    hasNewNotifications: boolean;
    notificationsImage: string;
    newNotificationsImage: string;
    onMarkUpToDateNotifications?: () => void;
}

const NotificationPanel: React.FC<PropsWithChildren<NewNotificationPanelProps>> = ({ 
    hasNewNotifications,
    notificationsImage,
    newNotificationsImage,
    onMarkUpToDateNotifications,
    children
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLAnchorElement | null>(null);

  const handleOpenNotifications = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
    if (onMarkUpToDateNotifications && hasNewNotifications){
        onMarkUpToDateNotifications();
    }
  };

  const handleCloseNotifications = () => {
    setAnchorEl(null);
  }

  return (
    <>
        <a
            aria-describedby='notifications-menu'
            onClick={handleOpenNotifications}
            aria-haspopup="true"
            aria-expanded="false"
            style={linkNotificationStyle}
        >
            <NotificationsIconWrapper
                hasNewNotifications={hasNewNotifications}
                notificationsImage={notificationsImage}
                newNotificationsImage={newNotificationsImage}
            />
        </a>
        <Popover
            id="notifications-menu"
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleCloseNotifications}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}            
        >
            <ContentWrapper style={{}} >
                {children}
            </ContentWrapper>
        </Popover>
    </>
  );
};

export default NotificationPanel;

const escapeProps = ['hasNewNotifications'];

const NotificationsIconWrapper = styled('div', {
  shouldForwardProp: prop => !escapeProps.includes(prop as string)
})<{
  hasNewNotifications: boolean;
  notificationsImage: string,
  newNotificationsImage: string
}>(props => {
  return {
    backgroundImage: `url(${
      props.hasNewNotifications ? props.newNotificationsImage : props.notificationsImage
    })`,
    width: '25px',
    height: '25px'
  };
});

const ContentWrapper = styled('div', {
  shouldForwardProp: prop => !escapeProps.includes(prop as string)
})<{
  style: CSSProperties;
}>(props => {
  return {
    padding: '2px 10px',
    color: 'white',
    borderRadius: '0px 0px 5px 5px',
    border: '1px solid #999999',
    backgroundColor: '#1B1C1C',
    borderTop: 'none',
    width: '222px',
    ...props.style
  };
});

const linkNotificationStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    padding: '0 0.75rem',
    height: '4.375rem',
    width: '50px',
    cursor: 'pointer'
}